import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { LayoutBlocksConfirmModal } from 'teacher-ui-client/components/layout-blocks/confirm-modal'

interface Signature {
  Element: Element
  Args: {
    collectionName: string
    onConfirm?: () => void
    onCancel: () => void
    isSubmitting: boolean
  }
}

export class BookLibraryConfirmBookChangesModal extends Component<Signature> {
  get showModal(): boolean {
    return !!this.args.onConfirm
  }

  get onConfirm() {
    const emptyFunction = () => {}
    return this.args.onConfirm ?? emptyFunction
  }

  <template>
    <LayoutBlocksConfirmModal
      @title={{t "bookLibrary.components.confirmBookChangesModal.title"}}
      @showModal={{this.showModal}}
      @cancel={{@onCancel}}
      @confirm={{this.onConfirm}}
      @cancelButtonText={{t "cancel"}}
      @confirmButtonText={{t "confirm"}}
      @isSubmitting={{@isSubmitting}}
      ...attributes
    >
      <div class="space-y-4 p-4">
        <p>{{t
            "bookLibrary.components.confirmBookChangesModal.aboutToChange"
            collectionName=@collectionName
            htmlSafe=true
          }}</p>
        <p>{{t "bookLibrary.components.confirmBookChangesModal.thisWillUpdate"}}</p>
        <p><strong>{{t "bookLibrary.components.confirmBookChangesModal.prompt"}}</strong></p>
      </div>
    </LayoutBlocksConfirmModal>
  </template>
}

export default BookLibraryConfirmBookChangesModal
